import { IconNames } from 'components/Icon';

export const listItems = [
  {
    id: 1,
    title: 'Choose an Issue',
    subtitle: 'Select the issue you’d like to focus on.',
    icon: IconNames.Check,
  },
  {
    id: 2,
    title: 'Choose an Amount',
    subtitle: 'Set the budget for your monthly recurring donation.',
    icon: IconNames.DollarSign,
  },
  {
    id: 3,
    title: 'Make an Impact',
    subtitle: 'Oath will direct your dollars where they are most needed.',
    icon: IconNames.ArrowRight,
  },
];
